import {Dispatcher} from 'flux';

/**
 * Simple interface for flux actions, which doesn't try to define a nice type signature for every
 * action.
 */
export interface FluxAction {
  actionType: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: any;
}

export default new Dispatcher<FluxAction>();
